import { render, staticRenderFns } from "./HIXJFHLG.vue?vue&type=template&id=90887208&scoped=true"
import script from "./HIXJFHLG.vue?vue&type=script&lang=js"
export * from "./HIXJFHLG.vue?vue&type=script&lang=js"
import style0 from "./HIXJFHLG.vue?vue&type=style&index=0&id=90887208&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90887208",
  null
  
)

export default component.exports